module.exports = __webpack_public_path__ + "img/sable_reseau.e9bf0acc.jpg";